
export class Room {
    constructor(data = {}) {
        // Properly initialize all fields with defaults
        this.name = data.name || '';
        this.phone_expression = data.phone_expression || '';
        this.floor_id = data.floor_id || (data.floor ? data.floor.id : null);
        this.floor = data.floor || null;
        this.remarks = data.remarks || null;
        this.reference_number = data.reference_number || '';
        this.color = data.color || '';
        this.image = data.image || '';
        this.images = data.images || [];

        // THIS IS THE MOST IMPORTANT LINE
        this.is_smoking = data.is_smoking ?? false;   // ← fixes your bug forever

        // For room types (pivot)
        this.types = data.types || [];
        this.selectedroomtypes = data.selectedroomtypes || [];
    }

    // Convert current instance → payload for API (create/update)
    toRequestModel() {
        return {
            name: this.name,
            phone_expression: this.phone_expression,
            floor_id: this.floor_id,
            remarks: this.remarks,
            is_smoking: this.is_smoking,        // ← now sent correctly
            types: this.types.map(t => ({
                room_type_id: t.room_type_id || t.id,
                amount: t.amount || t.amount_of_roomtype
            }))
        };
    }

    // Convert API response → Room instance (used when loading for Edit/View)
    static toViewModel(apiData) {
        return new Room({
            ...apiData,
            floor: apiData.floor,  // keep full floor object
            types: apiData.types || [],
            images: apiData.images || [],
            // Map types for edit form if needed
            selectedroomtypes: (apiData.types || []).map(t => ({
                id: t.room_type.id,
                name: t.room_type.name,
                amount_of_roomtype: t.amount
            }))
        });
    }
}
